import schedulesViewStateStore from "../../store/store";
import { IOpenShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";

export default mutatorAction('SET_OPEN_SHIFTS_IN_VIEW', function setOpenShiftsInView(
    openShiftsInView: IOpenShiftEntity[],
    viewState?: SchedulesViewStateStore | IPreviewSchedulePageStore
) {
    const store = viewState ? viewState : schedulesViewStateStore();
    store.openShiftsInView.clear();
    if (openShiftsInView && openShiftsInView.length) {
        for (let i = 0; i < openShiftsInView.length; i++) {
            store.openShiftsInView.set(openShiftsInView[i].id, openShiftsInView[i]);
        }
    }
});
